import React, {useEffect, useRef, useState} from 'react';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';
import {TabView, TabPanel} from 'primereact/tabview';
import {SplitButton} from 'primereact/splitbutton';
import {MenuItem} from 'primereact/menuitem';

import {ConfirmDialogService, FormatDisplay, ToastService, useForm} from '@iamsoftware/react-hooks';
import {DocumentSignService} from "../../service/DocumentSignService";
import {AgreementService, AgreementService as Service} from '../../app/hop-dong/quan-ly-hop-dong/AgreementService';
import {AppStorage} from '../../service/UserStorage';
import {Oauth2GoogleService} from '../../app/hop-dong/mau-hop-dong/Oauth2GoogleService';
import {AuthService} from '../../service/AuthService';

export const Detail = ({display, setDisplay, setRefresh, signingSecretCode, setSigningSecretCode}) => {
  const [data, setData] = useState(null)
  const [headerInfo, setHeaderInfo] = useState(null)
  const [displayDetail, setDisplayDetail] = useState(false)
  const [displayCode, setDisplayCode] = useState(null)
  const [reload, setReload] = useState(null)
  const [mainFiles, setMainFiles] = useState([])
  const [attachmentFiles, setAttachmentFiles] = useState([])
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [viewingAttachmentIndex, setViewingAttachmentIndex] = useState(null)
  const openedFileIdsRef = useRef<Set<string>>(new Set())
  const [mainFileReady, setMainFileReady] = useState<{[key: string]: boolean}>({})
  const [attachmentFileReady, setAttachmentFileReady] = useState<{[key: string]: boolean}>({})
  const [openingFileIds, setOpeningFileIds] = useState<Set<string>>(new Set())
  const [mainFileBlobUrls, setMainFileBlobUrls] = useState<{[key: string]: string}>({})
  const [attachmentFileBlobUrls, setAttachmentFileBlobUrls] = useState<{[key: string]: string}>({})
  const mainFileBlobUrlsRef = useRef<{[key: string]: string}>({})
  const attachmentFileBlobUrlsRef = useRef<{[key: string]: string}>({})

  const ensureToken = async () => {
    try {
      const res = await AuthService.getToken();
      if (res?.moquiSessionToken) {
        AppStorage.set('moquiSessionToken', res.moquiSessionToken);
      }
    } catch (e) {
      // ignore token errors, will rely on existing session if any
    }
  };
  useEffect(() => {
    if (display && display !== false && display !== 'false' && display !== null && display !== 'null') {
      Service.getHeaderInfo(display).then(data => {
        setHeaderInfo(data)
        if (data?.agreementDate) {
          data.agreementDate = FormatDisplay.date(new Date(data.agreementDate), 'YYYY-MM-DD');
        }
        // Lưu danh sách files
        setMainFiles(data?.mainFiles || [])
        setAttachmentFiles(data?.attachmentFiles || [])
        infoForm.setValue(data)
        detailForm.setValue(data)
      }).catch(error => {
      })
      setData(display)
    }
  }, [display]);


  useEffect(() => {
    if (reload && display && display !== false && display !== 'false' && display !== null && display !== 'null') {
      Service.getHeaderInfo(display).then(data => {
        setHeaderInfo(data)
        if (data?.agreementDate) {
          data.agreementDate = FormatDisplay.date(new Date(data.agreementDate), 'YYYY-MM-DD');
        }
        // Lưu danh sách files
        setMainFiles(data?.mainFiles || [])
        setAttachmentFiles(data?.attachmentFiles || [])
        infoForm.setValue(data)
        detailForm.setValue(data)
      }).catch(error => {
      })
    }
  }, [reload]);

  const agreementId = headerInfo?.agreementId || data?.agreementId;

  useEffect(() => {
    if (mainFiles.length === 0 || !agreementId) return
    
    const loadFiles = async () => {
      for (const file of mainFiles) {
        const fileId = file?.fileId || file?.description
        const isGoogleFile = file?.contentLocationTypeEnumId === 'CntLocGoogleDrive'
        const cacheKey = `main_${fileId || file.agreementContentId || mainFiles.indexOf(file)}`
        
        // Nếu đã ready rồi thì bỏ qua
        if (mainFileReady[cacheKey]) continue
        
        if (isGoogleFile && fileId) {
          try {
            await ensureToken();
            if (!openedFileIdsRef.current.has(fileId)) {
              await AgreementService.openContent(agreementId, fileId)
              openedFileIdsRef.current.add(fileId)
            }
            
            // Tải file dưới dạng blob để tránh CSP error
            const blob = await Oauth2GoogleService.getPdf(fileId)
            const blobUrl = URL.createObjectURL(blob)
            setMainFileBlobUrls(prev => {
              const next = {...prev, [cacheKey]: blobUrl}
              mainFileBlobUrlsRef.current = next
              return next
            })
            setMainFileReady(prev => ({...prev, [cacheKey]: true}))
          } catch (err) {
            console.error('Error loading Google file:', err)
            setMainFileReady(prev => ({...prev, [cacheKey]: true}))
          }
        } else {
          setMainFileReady(prev => ({...prev, [cacheKey]: true}))
        }
      }
    }
    
    loadFiles()
  }, [mainFiles])
  
  useEffect(() => {
    return () => {
      Object.values(mainFileBlobUrlsRef.current).forEach(url => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url)
        }
      })
      Object.values(attachmentFileBlobUrlsRef.current).forEach(url => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url)
        }
      })
    }
  }, [])


  const showDetail = () => {
    if (displayDetail === false) {
      setDisplayDetail(true)
    } else setDisplayDetail(false)
  }
  const signFile = async () => {
    if (signingSecretCode) {
      if (!data) {
        ToastService.error('Mã hợp đồng không hợp lệ. Vui lòng thử lại!');
        
        try {
          await Service.updateSigningError({
            referenceNumber: null,
            signingSecretCode: signingSecretCode,
            roleTypeId: headerInfo?.roleTypeId || 'PartyA'
          });
        } catch (apiError) {
        }
        
        return;
      }

      try {
        const signResult = await DocumentSignService.sign({
          referenceNumber: data,
          signingSecretCode: signingSecretCode
        });

        if (signResult?.success && signResult?.data?.signedFilesBase64?.length > 0) {
          const signedPdfBase64 = signResult.data.signedFilesBase64[0];
          const roleTypeId = signResult?.signatureLocationList?.[0]?.roleTypeId || signResult?.roleTypeId || 'PartyA';
          try {
            await Service.pushSignedData({
              signedBy: 'BUYER',
              base64FileData: signedPdfBase64,
              roleTypeId: roleTypeId, 
              referenceNumber: data,
              signingSecretCode: signingSecretCode
            });
            
            ToastService.success('Ký số thành công và đã lưu file!');
            setRefresh(Date.now());
            setDisplay(false);
            AppStorage.set('reload', String(Date.now()));
            setReload(Date.now());
          } catch (pushError) {
            try {
              await Service.updateSigningError({
                referenceNumber: data,
                signingSecretCode: signingSecretCode,
                roleTypeId: roleTypeId
              });
            } catch (apiError) {
            }
            
            ToastService.error('Ký số thành công nhưng lưu file thất bại!');
          }
        } else {
          const roleTypeId = signResult?.signatureLocationList?.[0]?.roleTypeId || signResult?.roleTypeId || headerInfo?.roleTypeId || 'PartyA';
          try {
            await Service.updateSigningError({
              referenceNumber: data,
              signingSecretCode: signingSecretCode,
              roleTypeId: roleTypeId
            });
          } catch (apiError) {
          }
        }
      } catch (error) {
        try {
          await Service.updateSigningError({
            referenceNumber: data,
            signingSecretCode: signingSecretCode,
            roleTypeId: headerInfo?.roleTypeId || 'PartyA'
          });
        } catch (apiError) {
        }
        if (error?.response?.status === 400 || error?.message?.includes('pull-data') || error?.config?.url?.includes('pull-data')) {
          ToastService.error('Lỗi khi tải dữ liệu ký số. Vui lòng thử lại!');
        } else {
          ToastService.error('Có lỗi khi thực hiện ký số.');
        }
      }
    } else {
      setDisplayCode(Date.now());
    }
  }
  const infoForm = useForm({
    fields: [
      {field: 'agreementNo', header: 'Số hợp đồng', disabled: true, className: 'md:col-3 xxx'},
      {field: 'agreementDate', header: 'Ngày hợp đồng', disabled: true, InputTextProps: {type: 'date'}, className: 'md:col-3 xxx'},
      {field: 'agreementTotal', header: 'Giá trị hợp đồng', disabled: true, type: 'InputNumber', className: 'md:col-3 xxx'},
      {
        type: 'custom', className: 'md:col-1 xxx', body: <Button style={{height: '30px', marginTop: '24px'}} icon={'pi pi-eye'} onClick={() => showDetail()}>
        </Button>
      },

    ]
  })
  const detailForm = useForm({
    fields: [
      {field: 'organizationPartyName', header: 'NCC ', disabled: true, className: 'md:col-4 xxx'},
      {field: 'organizationPseudoId', header: 'MST', disabled: true, className: 'md:col-2 xxx'},
      // {field: 'customerPartyName', header: 'Khách hàng', disabled: true, className: 'md:col-4 xxx'},
      // {field: 'customerPseudoId', header: 'MST', disabled: true, className: 'md:col-2 xxx'},
      // {field: 'address1', header: 'Địa chỉ ', disabled: true, className: 'md:col-6 xxx'},
      {field: 'itemText', header: 'Sản phẩm/dịch vụ', disabled: true, className: 'md:col-6 xxx'},
      {field: 'quantity', header: 'Số lượng ', disabled: true, type: 'InputNumber', className: 'md:col-2 xxx'},
      {field: 'unitAmount', header: 'Đơn giá', disabled: true, type: 'InputNumber', className: 'md:col-2 xxx'},
      {field: 'taxPercentage', header: 'Thuế suất', disabled: true, type: 'InputNumber', InputNumberProps: {suffix: '%'}, className: 'md:col-2 xxx'},
      {field: 'amount', header: 'Thành tiền trước thuế', disabled: true, type: 'InputNumber', className: 'md:col-2 xxx'},
      {field: 'taxTotal', header: 'Tiền thuế', disabled: true, type: 'InputNumber', className: 'md:col-2 xxx'},
      {field: 'amountTotal', header: 'Thành tiền sau thuế', disabled: true, type: 'InputNumber', className: 'md:col-2 xxx'},
    ]
  })

  const downloadSignTool = (arch: '64' | '32' = '64') => {
    const fileName = arch === '64' 
      ? 'IAMSigningToolSetup64bit.zip' 
      : 'IAMSigningToolSetup32bit.zip';
    window.open(`/iam/tool/${fileName}`);
  }

  const toolMenuItems: MenuItem[] = [
    {
      label: 'Tải tool ký 64-bit',
      icon: 'pi pi-download',
      command: () => downloadSignTool('64')
    },
    {
      label: 'Tải tool ký 32-bit',
      icon: 'pi pi-download',
      command: () => downloadSignTool('32')
  }
  ]
  const submitCode = () => {
    if (signingSecretCode) {
      setDisplayCode(null)
      signFile()
    } else {
      ToastService.error('Chưa nhập mã bí mật')
    }

  }
  const footer = (
    <div className="align-items-center justify-content-between md:col-12">
      <div className="flex justify-content-between">
        <div>
          <b className={'pt-2'} style={{color: 'red', fontSize: '20px'}}>Trạng thái: {headerInfo?.status}</b>
        </div>
        <div>
          <div className="flex">
            {headerInfo?.statusId !== 'AGT_SIGN_COMPLETED' && <Button label='Ký hợp đồng' severity='warning' icon="pi pi-pencil" onClick={() => signFile()}></Button>}
            {headerInfo?.statusId !== 'AGT_SIGN_COMPLETED' && <SplitButton 
              label='Tải tool ký' 
              severity='info' 
              icon="pi pi-download" 
              onClick={() => downloadSignTool('64')}
              model={toolMenuItems}
            />}
            <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm"
                    type="button" onClick={() => setDisplay(false)}/>
          </div>
        </div>
      </div>
    </div>
  );
  const codeFooter = (
    <div className="align-items-center justify-content-between md:col-12">
      <div className="flex  flex-row-reverse">
        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm"
                type="button" onClick={() => setDisplayCode(false)}/>
        <Button label='Xác nhận' severity='success' icon="pi pi-check" onClick={() => submitCode()}></Button>
      </div>
    </div>
  );
  const getFileUrl = (file) => {
    if (!file) return null
    
    if (file?.agreementContentId) {
      return `${Service.baseURL}/${Service.entity}/contents/${file.agreementContentId}/pdf?reload=${reload}`
    }
    
    return null
  }


  useEffect(() => {
    return () => {
      openedFileIdsRef.current.forEach(fileId => {
        if (agreementId) {
          AgreementService.closeContent(agreementId, fileId).catch(err => {
            console.error('Error closing editor permission:', err)
          })
        }
      })
      openedFileIdsRef.current.clear()
    }
  }, [])

  const handleCloseDialog = () => {
    openedFileIdsRef.current.forEach(fileId => {
      if (agreementId) {
        AgreementService.closeContent(agreementId, fileId).catch(err => {
          console.error('Error closing editor permission:', err)
        })
      }
    })
    openedFileIdsRef.current.clear()
    setDisplay(false)
  }

  return (
    <Dialog header={`Chi tiết hợp đồng`} maximized={true} draggable={false} footer={footer} visible={!!display}
            position="top" onHide={() => setDisplay(false)}>
      {infoForm.render()}
      {displayDetail === true && detailForm.render()}
      {data && (
        (mainFiles.length > 0 || attachmentFiles.length > 0) ? (
          <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
            <TabPanel header={`File chính${mainFiles.length > 0 ? ` (${mainFiles.length})` : ''}`}>
              {mainFiles.length > 0 ? (
                mainFiles.map((file, index) => {
                  const fileId = file?.fileId || file?.description
                  const isGoogleFile = file?.contentLocationTypeEnumId === 'CntLocGoogleDrive'
                  const cacheKey = `main_${fileId || index}`
                  const isReady = mainFileReady[cacheKey]
                  
                  let mainFileUrl = null
                  if (isGoogleFile) {
                    if (isReady && mainFileBlobUrls[cacheKey]) {
                      mainFileUrl = mainFileBlobUrls[cacheKey]
                    }
                  } 
                  
                  if (isGoogleFile && !isReady) {
                    return (
                      <div key={file.agreementContentId || index} style={{padding: '2rem', textAlign: 'center'}}>
                        <i className="pi pi-spin pi-spinner" style={{fontSize: '2rem', marginBottom: '1rem'}}></i>
                        <p>Đang tải file...</p>
                      </div>
                    )
                  }
                  
                  if (mainFileUrl) {
                    return (
                      <iframe 
                        key={file.agreementContentId || index}
                        src={mainFileUrl} 
                        title="Hợp đồng"
                        style={{width: '100%', height: 'calc(100vh - 300px)', border: 'none'}}
                      />
                    )
                  }
                  return null
                })
              ) : (
                <div style={{padding: '2rem', textAlign: 'center'}}>
                  <p>Không tìm thấy file ký số để hiển thị.</p>
                </div>
              )}
            </TabPanel>
            
            {attachmentFiles.length > 0 && (
            <TabPanel header={`File đính kèm (${attachmentFiles.length})`}>
              {attachmentFiles.length > 0 ? (
                <div style={{display: 'flex', flexDirection: 'column', gap: '1rem', height: '90%', overflow: 'auto'}}>
                  {attachmentFiles.map((file, index) => {
                    const isViewing = viewingAttachmentIndex === index
                    
                    return (
                      <div key={file.agreementContentId || index} style={{border: '1px solid #ddd', borderRadius: '4px', padding: '1rem'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: isViewing ? '0.5rem' : '0'}}>
                          <div>
                            <strong>{file.fileName || `File đính kèm ${index + 1}`}</strong>
                            {file.sequenceNum && <span style={{marginLeft: '0.5rem', color: '#666'}}></span>}
                          </div>
                          <div>
                            <Button 
                              label={isViewing ? "Ẩn" : "Xem"} 
                              icon={isViewing ? "pi pi-eye-slash" : "pi pi-eye"} 
                              className="p-button-sm p-button-outlined"
                              onClick={async () => {
                                if (!isViewing) {
                                  const fileId = file?.fileId || file?.description
                                  const cacheKey = `attachment_${fileId || index}`
                                  
                                  if (fileId) {
                                    try {
                                      await ensureToken();
                                      if (agreementId) {
                                        await AgreementService.openContent(agreementId, fileId);
                                      }
                                      if (!openedFileIdsRef.current.has(fileId)) {
                                        if (agreementId) {
                                          await AgreementService.openContent(agreementId, fileId)
                                        }
                                        openedFileIdsRef.current.add(fileId)
                                      }
                                      
                                      const blob = await Oauth2GoogleService.getPdf(fileId)
                                      const blobUrl = URL.createObjectURL(blob)
                                      setAttachmentFileBlobUrls(prev => {
                                        const next = {...prev, [cacheKey]: blobUrl}
                                        attachmentFileBlobUrlsRef.current = next
                                        return next
                                      })
                                      setAttachmentFileReady(prev => ({...prev, [cacheKey]: true}))
                                      setViewingAttachmentIndex(index)
                                      
                                      setTimeout(() => {
                                        if (agreementId) {
                                          AgreementService.closeContent(agreementId, fileId).catch(err => {
                                            console.error('Error closing editor permission after preview:', err)
                                          })
                                        }
                                        openedFileIdsRef.current.delete(fileId)
                                      }, 1000)
                                    } catch (err) {
                                      console.error('Error loading Google file:', err)
                                      ToastService.error('Không thể tải file')
                                    }
                                  }
                                } else {
                                  const fileId = file?.fileId || file?.description
                                  if (fileId && openedFileIdsRef.current.has(fileId)) {
                                    if (agreementId) {
                                      AgreementService.closeContent(agreementId, fileId).then(() => {
                                        openedFileIdsRef.current.delete(fileId)
                                      }).catch(err => {
                                        console.error('Error closing editor permission:', err)
                                      })
                                    }
                                  }
                                  setViewingAttachmentIndex(null)
                                }
                              }}
                            />
                          </div>
                        </div>
                        {isViewing && (() => {
                          const fileId = file?.fileId || file?.description
                          const cacheKey = `attachment_${fileId || index}`
                          const isReady = attachmentFileReady[cacheKey]
                          
                          if (!isReady) {
                            return (
                              <div style={{padding: '2rem', textAlign: 'center', height: '600px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border: '1px solid #ddd', borderRadius: '4px'}}>
                                <i className="pi pi-spin pi-spinner" style={{fontSize: '2rem', marginBottom: '1rem'}}></i>
                                <p>Đang tải file...</p>
                              </div>
                            )
                          }
                          
                          const displayUrl = attachmentFileBlobUrls[cacheKey]
                          
                          if (!displayUrl) {
                            return (
                              <div style={{padding: '2rem', textAlign: 'center', height: '600px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border: '1px solid #ddd', borderRadius: '4px'}}>
                                <p>Không thể tải file</p>
                              </div>
                            )
                          }
                          
                          return (
                            <iframe 
                              src={displayUrl} 
                              title={file.fileName || `File đính kèm ${index + 1}`}
                              style={{width: '100%', height: '600px', border: '1px solid #ddd', borderRadius: '4px'}}
                            />
                          )
                        })()}
                      </div>
                    )
                  })}
                </div>
              ) : (
                <div style={{padding: '2rem', textAlign: 'center'}}>
                  <p>Chưa có file đính kèm</p>
                </div>
              )}
            </TabPanel>
            )}
          </TabView>
        ) : (
          <div style={{padding: '2rem', textAlign: 'center'}}>
            <p>Không tìm thấy file ký số để hiển thị.</p>
          </div>
        )
      )}
      <Dialog header={`Nhập mã bí mật`} draggable={false} footer={codeFooter} visible={!!displayCode} style={{width: '30rem', height: '12rem',}} position="center" onHide={() => setDisplayCode(false)}>
        <InputText value={signingSecretCode} onChange={(e) => setSigningSecretCode(e.target.value)}/>
      </Dialog>
    </Dialog>
  );

}